import { Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'form-textarea-field',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
  styles: ['.form-textarea-field { display:flex;  flex: 1;}'],
  template: `
    <p-iftalabel class="flex-1">
      <textarea
        pInputText
        [formControl]="formControl"
        [formlyAttributes]="field"
        [pTooltip]="
          field.props['translate']
            ? (field.props['tooltip'] || '' | translate)
            : field.props['tooltip']
        "
        tooltipPosition="top"
        class="w-full"
        [placeholder]="
          field.props['translate']
            ? (field.props.placeholder || '' | translate)
            : field.props.placeholder
        "
      ></textarea>
      <label *ngIf="field.props.label" [htmlFor]="field.id">{{
        field.props['translate']
          ? (field.props.label | translate)
          : field.props.label
      }}</label>
    </p-iftalabel>
  `,
})
export class FormTextareaFieldType extends FieldType<FieldTypeConfig> {
  @HostBinding('class')
  readonly cssClass = 'form-textarea-field';
}
